module.exports = __webpack_public_path__ + "static/img/fpjz_selected_image.89f556f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplyFinance/fpjz_selected_image.png
// module id = qA2R
// module chunks = 44